export default class LeadForm {
  constructor(form, onSubmit) {
    this.form = form;
    this.onSubmit = onSubmit;
    this.formElements = this.form.querySelectorAll('input, select, textarea');
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.isValid = true;
    this.attachListeners();
  }

  attachListeners() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this), false);
    Array.from(this.formElements).forEach(input => {
      const boundSetInputValidity = this.setInputValidity.bind(this, input);
      input.addEventListener('blur', boundSetInputValidity);
      input.addEventListener('change', boundSetInputValidity);
    });
  }

  async handleSubmit(event) {
    event.preventDefault();

    const formValues = this.getFormValuesAndValidateForm();

    if (!this.isValid) {
      return false;
    }

    this.disableSubmit();

    try {
      await this.onSubmit(event, formValues);
    } catch (error) {
      // @todo something with this error
      console.error(error); // eslint-disable-line no-console
      throw error;
    } finally {
      this.enableSubmit();
    }
  }

  getInputValueFromDOM(input) {
    if (input.iti) {
      const dialCode = input.iti.selectedCountryData.dialCode;
      const prefixRegex = new RegExp(`^\\+${dialCode}`);
      return input.iti._getFullNumber().replace(prefixRegex, `+${dialCode}-`);
    }

    if (input.getAttribute('type') === 'radio') {
      if (!input.checked) {
        return null;
      }
    }

    return input.value;
  }

  setInputValidity(input) {
    const isValid = input.checkValidity();
    const invalidClass = 'invalid';
    const classListFunction = isValid ? 'remove' : 'add';
    const isRay = Array.from(input.classList).find(className => className.startsWith('ray-'));

    input.classList[classListFunction](invalidClass);

    if (input.iti && isRay) {
      input.parentElement.parentElement.classList[classListFunction](invalidClass);
    } else if (input.iti || isRay) {
      input.parentElement.classList[classListFunction](invalidClass);
    }

    this.isValid = this.isValid && isValid;
  }

  validate(input) {
    this.setInputValidity(input);
    return this.getInputValueFromDOM(input);
  }

  disableSubmit() {
    this.submitButton.disabled = true;
  }

  enableSubmit() {
    this.submitButton.disabled = false;
  }

  /**
   * Returns an object that contains all of the formvalues and sets form validity at the same time
   * @returns {any}
   */
  getFormValuesAndValidateForm() {
    this.isValid = true;

    return Array.from(this.formElements).reduce((acc, input) => {
      const inputValue = this.validate(input);
      if (inputValue) {
        acc[input.name] = inputValue;
      }
      return acc;
    }, {});
  }
}
